import Request from "../model/Request";
import Response from "../model/Response";
import {RestClient} from "../util/RestClient";
import {Config} from "../util/Config";

export module SMSService {

    export async function sendSMSToClients(clients: string[], content: string): Promise<Response<any>> {
        const url = Config.get("SEND_CLIENT_SMS_URL");
        const request = new Request(url, {clients, content});
        return await RestClient.post(request);
    }

    export async function sendSMSToAgencyClients(agencies: string[], content: string): Promise<Response<any>> {
        const url = Config.get("SEND_AGENCY_CLIENT_SMS_URL");
        const request = new Request(url, {agencies, content});
        return await RestClient.post(request);
    }
}